import { useState } from "react";
import { useTranslation } from "react-i18next";

import { Table } from "@pentabd/ui";

import { DeleteConfirmationModal } from "@components";
import { TableColumn } from "./TableColumn";

import { deleteDossier } from "@api/dossier";
import { STATUS } from "@constants/status.hrm";
// import { TablePagination } from "@helpers/tablePagination";

const { SUCCESS, FAILED } = STATUS;

interface DossierTableProps {
  data: any;
  setIsSuccessModalOpen: (arg: boolean) => void;
  setIsErrorModalOpen: (arg: boolean) => void;
}

export const DossierTable = ({
  data,
  setIsSuccessModalOpen,
  setIsErrorModalOpen,
}: DossierTableProps) => {
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const [itemID, setItemID] = useState<number>();

  const { t } = useTranslation();
  const { data: dossierData, handleDeleteDossier } = data || {};
  const { data: tableData } = dossierData || {};

  const closeConfirmationModal = () => setIsConfirmationModalOpen(false);

  const deleteAction = () => {
    deleteDossier(itemID as number, (response) => {
      setIsErrorModalOpen(false);
      if (response.status === SUCCESS) {
        setIsSuccessModalOpen(true);
        handleDeleteDossier(itemID as number);
      } else if (response.status === FAILED) setIsErrorModalOpen(true);
    });
    closeConfirmationModal();
  };

  return (
    <div className="mb-9 py-10">
      {isConfirmationModalOpen && (
        <DeleteConfirmationModal
          isModalOpen={isConfirmationModalOpen}
          action={deleteAction}
          onClose={closeConfirmationModal}
        />
      )}
      <Table
        columns={TableColumn(t, setIsConfirmationModalOpen, setItemID)}
        rows={tableData}
        // actions={[
        //   {
        //     customIcon: <IconTrash01 size="20" fill="danger" />,
        //     onClick: (id) => {
        //       setIsConfirmationModalOpen(true);
        //       setItemID(id as number);
        //     },
        //   },
        // ]}
        // pagination={TablePagination(pagination, handleQuery)}
      />
    </div>
  );
};
